import React from "react";
import GoogleMapReact from "google-map-react";
import { constants } from "../../resource/constants";
import themePropTypes from "../theme-prop-types";

export const DEFAULT_CENTER = [0, 0];

const GMap = ({ renderLocations, center = DEFAULT_CENTER, children }) => (
  <GoogleMapReact
    bootstrapURLKeys={{ key: constants.googleApiKey }}
    defaultZoom={12}
    onGoogleApiLoaded={renderLocations}
    center={center}
    yesIWantToUseGoogleMapApiInternals
    options={{
      clickableIcons: false,
      disableDoubleClickZoom: true,
      scrollwheel: false
    }}
  >
    {children}
  </GoogleMapReact>
);

GMap.propTypes = themePropTypes.gMap;

export default GMap;
